import React from "react";

const Story = () => {
  return (
    <>
      <div>
        <a href="https://github.com/JoelDeonDsouza/teslaApp">
          {/* ! React Hydration Error */}
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/e8/Tesla_logo.png/600px-Tesla_logo.png?20210117060557"
            alt="img"
            layout="fill"
            className="rounded-full p-[1.5px] border-[3px] border-red-500"
            width={70}
            height={70}
          />
          <p className="text-xs w-[60px] truncate text-center">Tesla app</p>
        </a>
      </div>

      <div>
        <a href="https://github.com/JoelDeonDsouza/Celestial-Energy-web-app">
          {/* ! React Hydration Error */}
          <img
            src="https://img.icons8.com/external-kiranshastry-lineal-color-kiranshastry/344/external-code-coding-kiranshastry-lineal-color-kiranshastry-2.png"
            alt="img"
            layout="fill"
            className="rounded-full p-[1.5px] border-[3px] border-red-500"
            width={70}
            height={70}
          />
          <p className="text-xs w-[60px] truncate text-center">Web app</p>
        </a>
      </div>

      <div>
        <a href="https://github.com/JoelDeonDsouza/gitbin">
          {/* ! React Hydration Error */}
          <img
            src="https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png"
            alt="img"
            layout="fill"
            className="rounded-full p-[1.5px] border-[3px] border-red-500"
            width={70}
            height={70}
          />
          <p className="text-xs w-[60px] truncate text-center">Github Clone</p>
        </a>
      </div>

      <div>
        <a href="https://github.com/JoelDeonDsouza/jabber">
          {/* ! React Hydration Error */}
          <img
            src="https://img.icons8.com/office/2x/chat.png"
            alt="img"
            layout="fill"
            className="rounded-full p-[1.5px] border-[3px] border-red-500"
            width={70}
            height={70}
          />
          <p className="text-xs w-[60px] truncate text-center">Chat app</p>
        </a>
      </div>

      <div>
        <a href="https://github.com/JoelDeonDsouza/Front-End-Online-Bank-App">
          {/* ! React Hydration Error */}
          <img
            src="https://img.icons8.com/nolan/2x/merchant-account.png"
            alt="img"
            layout="fill"
            className="rounded-full p-[1.5px] border-[3px] border-red-500"
            width={70}
            height={70}
          />
          <p className="text-xs w-[60px] truncate text-center">Bank app</p>
        </a>
      </div>

      <div>
        <a href="https://github.com/JoelDeonDsouza/React-Translator-app">
          {/* ! React Hydration Error */}
          <img
            src="https://img.icons8.com/external-xnimrodx-blue-xnimrodx/344/external-translate-discussion-xnimrodx-blue-xnimrodx.png"
            alt="img"
            layout="fill"
            className="rounded-full p-[1.5px] border-[3px] border-red-500"
            width={70}
            height={70}
          />
          <p className="text-xs w-[60px] truncate text-center">Translate app</p>
        </a>
      </div>

      <div>
        <a href="https://github.com/JoelDeonDsouza/flappy-bird-react-app">
          {/* ! React Hydration Error */}
          <img
            src="https://img.icons8.com/color/2x/games-folder.png"
            alt="img"
            layout="fill"
            className="rounded-full p-[1.5px] border-[3px] border-red-500"
            width={70}
            height={70}
          />
          <p className="text-xs w-[60px] truncate text-center">Flappy Bird app</p>
        </a>
      </div>

      <div>
        <a href="https://github.com/JoelDeonDsouza/speechDecoder">
          {/* ! React Hydration Error */}
          <img
            src="https://img.icons8.com/color/2x/voice-recognition-scan.png"
            alt="img"
            layout="fill"
            className="rounded-full p-[1.5px] border-[3px] border-red-500"
            width={70}
            height={70}
          />
          <p className="text-xs w-[60px] truncate text-center">Speech Decoder</p>
        </a>
      </div>

      <div>
        <a href="https://github.com/JoelDeonDsouza/Blind-Times">
          {/* ! React Hydration Error */}
          <img
            src="https://img.icons8.com/color/2x/apple-app-store--v3.png"
            alt="img"
            layout="fill"
            className="rounded-full p-[1.5px] border-[3px] border-red-500"
            width={70}
            height={70}
          />
          <p className="text-xs w-[60px] truncate text-center">Native app</p>
        </a>
      </div>

      <div>
        <a href="https://github.com/JoelDeonDsouza/React-TODO-App">
          {/* ! React Hydration Error */}
          <img
            src="https://img.icons8.com/dusk/2x/list.png"
            alt="img"
            layout="fill"
            className="rounded-full p-[1.5px] border-[3px] border-red-500"
            width={70}
            height={70}
          />
          <p className="text-xs w-[60px] truncate text-center">To-Do app</p>
        </a>
      </div>

      <div>
        <a href="https://github.com/JoelDeonDsouza/ShopNow">
          {/* ! React Hydration Error */}
          <img
            src="https://img.icons8.com/plasticine/2x/online-store.png"
            alt="img"
            layout="fill"
            className="rounded-full p-[1.5px] border-[3px] border-red-500"
            width={70}
            height={70}
          />
          <p className="text-xs w-[60px] truncate text-center">Shop app</p>
        </a>
      </div>

      <div>
        <a href="https://github.com/JoelDeonDsouza/Tic-Tac-Toe">
          {/* ! React Hydration Error */}
          <img
            src="https://img.icons8.com/external-flat-icons-inmotus-design/2x/external-game-games-flat-icons-inmotus-design.png"
            alt="img"
            layout="fill"
            className="rounded-full p-[1.5px] border-[3px] border-red-500"
            width={70}
            height={70}
          />
          <p className="text-xs w-[60px] truncate text-center">Tic-Tac-Toe</p>
        </a>
      </div>

      <div>
        <a href="https://github.com/JoelDeonDsouza/Js-Movie-site">
          {/* ! React Hydration Error */}
          <img
            src="https://img.icons8.com/color/2x/cinema-.png"
            alt="img"
            layout="fill"
            className="rounded-full p-[1.5px] border-[3px] border-red-500"
            width={70}
            height={70}
          />
          <p className="text-xs w-[60px] truncate text-center">Movie app</p>
        </a>
      </div>

      <div>
        <a href="https://github.com/JoelDeonDsouza/Bitcoin-PriceChecker">
          {/* ! React Hydration Error */}
          <img
            src="https://img.icons8.com/color/2x/average-2.png"
            alt="img"
            layout="fill"
            className="rounded-full p-[1.5px] border-[3px] border-red-500"
            width={70}
            height={70}
          />
          <p className="text-xs w-[60px] truncate text-center">Bit-coin app</p>
        </a>
      </div>

      <div>
        <a href="https://github.com/JoelDeonDsouza/React-Weather-App">
          {/* ! React Hydration Error */}
          <img
            src="https://img.icons8.com/clouds/2x/marker-sun.png"
            alt="img"
            layout="fill"
            className="rounded-full p-[1.5px] border-[3px] border-red-500"
            width={70}
            height={70}
          />
          <p className="text-xs w-[60px] truncate text-center">Weather app</p>
        </a>
      </div>

      <div>
        <a href="https://github.com/JoelDeonDsouza/alphabbet">
          {/* ! React Hydration Error */}
          <img
            src="https://img.icons8.com/clouds/2x/fonts-app.png"
            alt="img"
            layout="fill"
            className="rounded-full p-[1.5px] border-[3px] border-red-500"
            width={70}
            height={70}
          />
          <p className="text-xs w-[60px] truncate text-center">Alphabbet app</p>
        </a>
      </div>
    </>
  );
};

export default Story;
